import React from 'react';
import { Phone, FileText, MessageSquareQuote } from 'lucide-react';
import { useDrawers } from '../../contexts/DrawerContext';
export function MobileActionBar() {
  const {
    openQuote,
    openUpload
  } = useDrawers();
  return <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden p-3" data-id="element-478" data-mp="1bzkdczi1f9ct">
      <div className="flex items-stretch gap-2 rounded-2xl bg-ink/95 backdrop-blur shadow-warm p-1.5" data-id="element-479" data-mp="172agiysbjvey">
        <a href="tel:+61386172600" className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2 min-h-[48px] rounded-xl text-cream hover:bg-white/10 transition-colors" data-id="element-480" data-mp="1237b3d8ffn6g">
          <Phone className="w-5 h-5" data-id="element-481" data-mp="t32c9rhatx3w" />
          <span className="text-[10px] font-semibold uppercase tracking-wide" data-id="element-482" data-mp="t43o3y652nmo">
            Call
          </span>
        </a>
        <button onClick={openUpload} className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2 min-h-[48px] rounded-xl text-cream hover:bg-white/10 transition-colors" data-id="element-483" data-mp="2ng0i9yvyu7lf">
          <FileText className="w-5 h-5" data-id="element-484" data-mp="1crtkz2c8cidg" />
          <span className="text-[10px] font-semibold uppercase tracking-wide" data-id="element-485" data-mp="1cqrxtzhxw5fd">
            Upload
          </span>
        </button>
        <button onClick={openQuote} className="flex-1 flex flex-col items-center justify-center gap-0.5 py-2 min-h-[48px] rounded-xl bg-accent text-white hover:bg-accent-dark transition-colors" data-id="element-486" data-mp="1grlmiv37ho9b">
          <MessageSquareQuote className="w-5 h-5" data-id="element-487" data-mp="1viayw0sel9er" />
          <span className="text-[10px] font-semibold uppercase tracking-wide" data-id="element-488" data-mp="1vjmcstfkbxjl">
            Quote
          </span>
        </button>
      </div>
    </div>;
}